import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogDismiss,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  Button,
} from '@barfacil/barfacil-ui'
import { AlertCircle } from 'lucide-react'

import { useUnauthorizedContext } from '@/contexts/unauthorized-context'

type NonExistentUserFeedbackAlertDialogProps = {
  open: boolean
  isInternal?: boolean
  onClose: () => void
}

export const NonExistentUserFeedbackAlertDialog = ({
  open,
  isInternal = true,
  onClose,
}: NonExistentUserFeedbackAlertDialogProps) => {
  const { closeUnauthorizedDialog } = useUnauthorizedContext()

  function handleAdmRedirect() {
    if (isInternal) {
      return onClose()
    }

    window.location.href = import.meta.env.VITE_ADM_URL
  }

  function handleSupportRedirect() {
    window.open(import.meta.env.VITE_SUPPORT_URL, '_blank')
  }

  function handleOnClose() {
    closeUnauthorizedDialog()
    onClose()
  }

  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="mb-2">
            <AlertCircle className="text-red-500" size={28} />
          </div>

          <AlertDialogTitle>Empresa não cadastrada no AGP</AlertDialogTitle>

          <AlertDialogDescription className="flex flex-col gap-1 font-medium">
            Não foi possível acessar o BackOffice, pois a empresa não está
            cadastrada no sistema AGP. Entre em contato com o suporte ou retorne
            ao Bar Fácil ADM.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="mt-4 max-sm:gap-2">
          <Button variant="tertiary" onClick={handleAdmRedirect}>
            {isInternal ? 'Voltar' : 'Acessar Bar Fácil ADM'}
          </Button>

          <Button variant="secondary" onClick={handleSupportRedirect}>
            Falar com o suporte
          </Button>
        </AlertDialogFooter>

        <AlertDialogDismiss
          className="absolute right-6 top-6"
          onClick={handleOnClose}
        />
      </AlertDialogContent>
    </AlertDialog>
  )
}
